// C:\Users\ignac\OneDrive\Escritorio\imagenes_productos\callcenter3\src\pages\Pedidos.jsx
import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import img1 from '../images/1.png';
import img2 from '../images/2.png';
import img3 from '../images/3.png';
import img4 from '../images/4.png';
import img5 from '../images/5.png';
import nuevoBotonImg from '../images/pngegg.png';
import editarImg from '../images/editar.png';
import eliminarImg from '../images/eliminar.png';
import cambiarEstadoImg from '../images/cambiar.png';
import telegramImg from '../images/telegram.webp';
import alarmSound from '../images/japanese-eas-alarm.mp3';
import '../styles/Pedidos.css';
import { useNavigate } from 'react-router-dom';
import MobileStatus from '../components/MobileStatus';

dayjs.extend(customParseFormat);

const opcionesProductos = [
  'Gas 15kg Normal',
  'Gas 45kg Normal',
  'Gas 5kg Normal',
  'Gas 11kg Normal',
  'Gas 15kg VMA',
];

const etiquetasMovil = {
  M01: 'M01 (IVAN)',
  M02: 'M02 (IVER)',
  M03: 'M03 (HERNAN MENA)',
  M04: 'M04 (PATRICIO CASTILLO)',
  M05: 'M05 (WILLIAM)',
  M06: 'M06 (HYOVER)',
  M07: 'M07 (ABEL)',
  M08: 'M08 (HECTOR)',
  M09: 'M09 (SEBASTIAN)',
  M10: 'M10 (ALAIN)',
  M11: 'M11 (EDGAR)',
  M12: 'M12 (SANTIAGO)',
  M13: 'M13 (DAVID)'
};

const opcionesEstado = ['Despacho 🚚', 'Entregado', 'Pendiente 💡', 'Anulado', 'Programado 🕜'];
const opcionesCiudad = ['Arica', 'Antofagasta', 'Mejillones'];
const opcionesOrigen = ['Call Center', 'DUO', 'RR SS', 'Whatsapp'];

const ordenarContactos = (a, b) => {
  const esMovilA = /^M\d+/i.test(a.movil);
  const esMovilB = /^M\d+/i.test(b.movil);

  if (esMovilA && !esMovilB) return -1;
  if (!esMovilA && esMovilB) return 1;

  return a.movil.localeCompare(b.movil, 'es', { numeric: true, sensitivity: 'base' });
};

const construirOpcionesMovil = (contactos, searchTerm = '') => {
  const clavesPrioritarias = Object.keys(etiquetasMovil);

  const listaPrioritarios = clavesPrioritarias.map(movil => ({
    movil,
    etiqueta: etiquetasMovil[movil],
  }));

  const listaContactos = contactos
    .slice()
    .sort(ordenarContactos)
    .map(c => ({
      movil: c.movil,
      etiqueta: c.movil,
    }));

  const lista = [...listaPrioritarios, ...listaContactos];

  const term = (searchTerm || '').toLowerCase();
  if (!term) return lista;

  return lista.filter(op => op.movil.toLowerCase().includes(term));
};

function generarNumeroPedido() {
  const randomNumber = Math.floor(100000 + Math.random() * 900000);
  return `90${randomNumber}`;
}

const dedupeByCampo2 = (arr) => {
  const map = new Map();
  for (const item of arr) {
    const key = item?.campo_2;
    if (!key) continue;
    if (!map.has(key)) map.set(key, item); // mantiene el primero
  }
  return Array.from(map.values());
};

const normalizarCiudad = (valor) =>
  String(valor || '').trim().toLowerCase();

const obtenerCiudadPermitida = () => {
  const role = localStorage.getItem('role') || '';
  const ciudad = localStorage.getItem('ciudad_usuario') || '';

  if (role === 'Administrator' || role === 'Administrador') return 'Todas';
  if (ciudad === 'Arica') return 'Arica';
  if (ciudad === 'Antofagasta') return 'Antofagasta';
  if (ciudad === 'Mejillones') return 'Mejillones';

  return 'Todas';
};

const filtrarPorCiudadUsuario = (lista) => {
  const ciudadPermitida = obtenerCiudadPermitida();

  if (ciudadPermitida === 'Todas') return lista;

  return lista.filter((pedido) =>
    normalizarCiudad(pedido.campo_yy) === normalizarCiudad(ciudadPermitida)
  );
};

const getCiudadInicialNuevaFila = () => {
  const ciudadPermitida = obtenerCiudadPermitida();
  return ciudadPermitida === 'Todas' ? '' : ciudadPermitida;
};

function Pedidos() {
  const navigate = useNavigate();
  const ciudadPermitida = obtenerCiudadPermitida();
  const puedeElegirCiudad = ciudadPermitida === 'Todas';

  // Estados
  const [pedidos, setPedidos] = useState([]);
  const [nuevaFila, setNuevaFila] = useState({
    campo_2: generarNumeroPedido(),
    campo_4: '',
    campo_7: '',
    campo_8: '',
    campo_9: '',
    campo_13: '',
    campo_14: '',
    campo_10: '',
    campo_11: '',
    campo_12: '',
    campo_6: 'Despacho 🚚',
    campo_yy: getCiudadInicialNuevaFila(),
    latitud: '',
    longitud: '',
    campo_geocode: '',
  });

  const [contadorCampo1, setContadorCampo1] = useState(1);
  const [editando, setEditando] = useState(null);
  const [estaEditando, setEstaEditando] = useState(false);
  const [editandoEstado, setEditandoEstado] = useState(null);
  const [errores, setErrores] = useState('');

  // Ref para el input de dirección (Autocomplete de Google)
  const inputDireccionRef = useRef(null);

  // Estados para popups y notificaciones
  const [showWhatsappPopup, setShowWhatsappPopup] = useState(false);
  const [currentWhatsappOrder, setCurrentWhatsappOrder] = useState(null);
  const audioRef = useRef(null);
  const timeoutRef = useRef(null);

  // ✅ Popup "Google encontró dirección" (usar Google o guardar manual)
  const [showDireccionPopup, setShowDireccionPopup] = useState(false);
  const [direccionSugerida, setDireccionSugerida] = useState(null); // { formatted, lat, lng }
  const [pedidoPendiente, setPedidoPendiente] = useState(null);

  // Estado para pedidos notificados de WhatsApp
  const [notifiedWhatsappOrders, setNotifiedWhatsappOrders] = useState(() => {
    const saved = localStorage.getItem('notifiedWhatsappOrders');
    return saved ? JSON.parse(saved) : [];
  });

  // Contactos (móviles) del JSON
  const [contactos, setContactos] = useState([]);

  // ✅ Tick para refrescar el "Tiempo" sin re-escribir el array pedidos cada segundo
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  // Lógica del sonido de alarma
  useEffect(() => {
    audioRef.current = new Audio(alarmSound);
    audioRef.current.preload = 'auto';
  }, []);

  // Guardamos en localStorage los pedidos ya notificados por WhatsApp
  useEffect(() => {
    localStorage.setItem('notifiedWhatsappOrders', JSON.stringify(notifiedWhatsappOrders));
  }, [notifiedWhatsappOrders]);

  // Cargar contactos
  useEffect(() => {
    const fetchContactos = async () => {
      try {
        const response = await fetch('https://pedidos.ayvgas.cl/pedidos/contactos.json');
        if (!response.ok) throw new Error('Error al cargar contactos.json');
        const data = await response.json();
        setContactos(data);
      } catch (error) {
        console.error('Error al cargar contactos:', error);
      }
    };
    fetchContactos();
  }, []);

  // Cargar pedidos al montar
  useEffect(() => {
    cargarDatos();
  }, []);

  // Cada 5s, si no estamos editando, actualizamos la data
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!estaEditando) {
        actualizarSoloFila();
      }
    }, 5000);
    return () => clearInterval(intervalId);
  }, [estaEditando]);

  // Verificar pedidos nuevos de WhatsApp
  useEffect(() => {
    pedidos.forEach(pedido => {
      const origenLower = (pedido.campo_12 || '').toLowerCase();
      if (origenLower === 'whatsapp' && !notifiedWhatsappOrders.includes(pedido.campo_2)) {
        handleNewPedido(pedido);
      }
    });
  }, [pedidos, notifiedWhatsappOrders]);

  // Inicializar Autocomplete de Google Places si está disponible
  useEffect(() => {
    if (window.google && window.google.maps && window.google.maps.places) {
      inicializarAutocomplete();
    }
  }, []);

  // ---- Funciones ----

  const inicializarAutocomplete = () => {
    if (window.google && window.google.maps && window.google.maps.places && inputDireccionRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(inputDireccionRef.current, {
        types: ['address'],
        componentRestrictions: { country: 'cl' },
      });
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place && place.formatted_address && place.geometry) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          const campo_geocode = `${lat},${lng}`;
          setNuevaFila(prev => ({
            ...prev,
            campo_7: place.formatted_address.toUpperCase(),
            latitud: lat,
            longitud: lng,
            campo_geocode,
          }));
        }
      });
    }
  };

  // ✅ Si NO seleccionaron sugerencia, intentamos geocodificar lo escrito al guardar
  const geocodificarDireccion = (texto, ciudad) => {
    return new Promise((resolve) => {
      if (!window.google?.maps?.Geocoder) return resolve(null);

      const geocoder = new window.google.maps.Geocoder();
      const address = `${texto}, ${ciudad || ''}, Chile`;

      geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK' && Array.isArray(results) && results.length > 0) {
          const r = results[0];
          const lat = r.geometry.location.lat();
          const lng = r.geometry.location.lng();
          resolve({
            formatted: r.formatted_address,
            lat,
            lng,
          });
        } else {
          resolve(null);
        }
      });
    });
  };

  const resetFormularioNuevaFila = () => {
    setNuevaFila({
      campo_2: generarNumeroPedido(),
      campo_4: '',
      campo_7: '',
      campo_8: '',
      campo_9: '',
      campo_13: '',
      campo_14: '',
      campo_10: '',
      campo_11: '',
      campo_12: '',
      campo_6: 'Despacho 🚚',
      campo_yy: getCiudadInicialNuevaFila(),
      latitud: '',
      longitud: '',
      campo_geocode: '',
    });
  };

  const limpiarPopupDireccion = () => {
    setShowDireccionPopup(false);
    setDireccionSugerida(null);
    setPedidoPendiente(null);
  };

  const afterGuardarOK = async () => {
    await cargarDatos();
    setContadorCampo1(prev => prev + 1);
    resetFormularioNuevaFila();
  };

  const handleUsarDireccionGoogle = async () => {
    if (!pedidoPendiente || !direccionSugerida) {
      limpiarPopupDireccion();
      return;
    }

    const pedidoConGoogle = {
      ...pedidoPendiente,
      campo_7: (direccionSugerida.formatted || '').toUpperCase(),
      latitud: direccionSugerida.lat,
      longitud: direccionSugerida.lng,
      campo_geocode: `${direccionSugerida.lat},${direccionSugerida.lng}`,
    };

    try {
      setErrores('');
      limpiarPopupDireccion();
      await guardarEnArchivo(pedidoConGoogle);
      await afterGuardarOK();
    } catch (error) {
      console.error('Error al guardar con dirección Google:', error);
      setErrores('Hubo un error al guardar el pedido.');
    }
  };

  const handleGuardarManualDireccion = async () => {
    if (!pedidoPendiente) {
      limpiarPopupDireccion();
      return;
    }

    try {
      setErrores('');
      limpiarPopupDireccion();
      await guardarEnArchivo(pedidoPendiente); // guarda tal cual (manual)
      await afterGuardarOK();
    } catch (error) {
      console.error('Error al guardar dirección manual:', error);
      setErrores('Hubo un error al guardar el pedido.');
    }
  };

  const handleEditChange = (e, index) => {
    const { name, value } = e.target;
    const nuevosPedidos = [...pedidos];
    nuevosPedidos[index] = { ...nuevosPedidos[index], [name]: value };
    setPedidos(nuevosPedidos);
  };

  // Cargar datos forzando "no-cache"
  const cargarDatos = async () => {
    const tiempo = Date.now();
    try {
      const [pedidosArica, pedidosAntofagasta, pedidosCallCenter] = await Promise.all([
        fetch(`https://pedidos.ayvgas.cl/pedidos/pedidos.json?t=${tiempo}`, { cache: 'no-store' }).then(res => {
          if (!res.ok) throw new Error(`Error ${res.status} al cargar pedidos.json`);
          return res.json();
        }),
        fetch(`https://pedidos.ayvgas.cl/pedidos/pedidos_antofagasta.json?t=${tiempo}`, { cache: 'no-store' }).then(res => {
          if (!res.ok) throw new Error(`Error ${res.status} al cargar pedidos_antofagasta.json`);
          return res.json();
        }),
        fetch(`https://pedidos.ayvgas.cl/pedidos/pedido_callcenter.json?t=${tiempo}`, { cache: 'no-store' }).then(res => {
          if (!res.ok) throw new Error(`Error ${res.status} al cargar pedido_callcenter.json`);
          return res.json();
        }),
      ]);

      const pedidosAricaArray = Array.isArray(pedidosArica)
        ? pedidosArica
        : Object.keys(pedidosArica).map(key => pedidosArica[key]);

      const pedidosAntofagastaArray = Array.isArray(pedidosAntofagasta)
        ? pedidosAntofagasta
        : Object.keys(pedidosAntofagasta).map(key => pedidosAntofagasta[key]);

      const pedidosCallCenterArray = Array.isArray(pedidosCallCenter)
        ? pedidosCallCenter
        : Object.keys(pedidosCallCenter).map(key => pedidosCallCenter[key]);

      const pedidosAricaConCiudad = pedidosAricaArray.map(pedido => ({
        ...pedido,
        campo_yy: 'Arica',
        campo_12: pedido.campo_12 || 'DUO',
        origen: 'pedidos.json',
      }));

      const pedidosAntofagastaConCiudad = pedidosAntofagastaArray.map(pedido => ({
        ...pedido,
        campo_yy: 'Antofagasta',
        campo_12: pedido.campo_12 || 'Call Center',
        origen: 'pedidos_antofagasta.json',
      }));

      const pedidosCallCenterConCiudad = pedidosCallCenterArray.map(pedido => ({
        ...pedido,
        campo_yy: pedido.campo_yy || 'Arica',
        campo_12: pedido.campo_12 || 'DUO',
        origen: 'pedido_callcenter.json',
      }));

      const pedidosCombinados = [
        ...pedidosAricaConCiudad,
        ...pedidosAntofagastaConCiudad,
        ...pedidosCallCenterConCiudad,
      ];

      const pedidosUnicos = dedupeByCampo2(pedidosCombinados);

      const maxCampo1 = Math.max(...pedidosUnicos.map(p => Number(p.campo_1) || 0), 0);
      setContadorCampo1(maxCampo1 + 1);
      setPedidos(filtrarPorCiudadUsuario(pedidosUnicos));
    } catch (error) {
      console.error('Error al cargar los pedidos:', error);
    }
  };

  const actualizarSoloFila = async () => {
    const tiempo = Date.now();
    try {
      const [pedidosArica, pedidosAntofagasta, pedidosCallCenter] = await Promise.all([
        fetch(`https://pedidos.ayvgas.cl/pedidos/pedidos.json?t=${tiempo}`, { cache: 'no-store' }).then(async res => {
          if (!res.ok) throw new Error(`Error ${res.status} al cargar pedidos.json`);
          return JSON.parse(await res.text());
        }),
        fetch(`https://pedidos.ayvgas.cl/pedidos/pedidos_antofagasta.json?t=${tiempo}`, { cache: 'no-store' }).then(async res => {
          if (!res.ok) throw new Error(`Error ${res.status} al cargar pedidos_antofagasta.json`);
          return JSON.parse(await res.text());
        }),
        fetch(`https://pedidos.ayvgas.cl/pedidos/pedido_callcenter.json?t=${tiempo}`, { cache: 'no-store' }).then(async res => {
          if (!res.ok) throw new Error(`Error ${res.status} al cargar pedido_callcenter.json`);
          return JSON.parse(await res.text());
        }),
      ]);

      const pedidosAricaArray = Array.isArray(pedidosArica)
        ? pedidosArica
        : Object.keys(pedidosArica).map(key => pedidosArica[key]);

      const pedidosAntofagastaArray = Array.isArray(pedidosAntofagasta)
        ? pedidosAntofagasta
        : Object.keys(pedidosAntofagasta).map(key => pedidosAntofagasta[key]);

      const pedidosCallCenterArray = Array.isArray(pedidosCallCenter)
        ? pedidosCallCenter
        : Object.keys(pedidosCallCenter).map(key => pedidosCallCenter[key]);

      const pedidosAricaConCiudad = pedidosAricaArray.map(pedido => ({
        ...pedido,
        campo_yy: 'Arica',
      }));

      const pedidosAntofagastaConCiudad = pedidosAntofagastaArray.map(pedido => ({
        ...pedido,
        campo_yy: 'Antofagasta',
      }));

      const pedidosCallCenterConCiudad = pedidosCallCenterArray.map(pedido => ({
        ...pedido,
        campo_yy: pedido.campo_yy || 'Arica',
      }));

      const pedidosCombinados = [
        ...pedidosAricaConCiudad,
        ...pedidosAntofagastaConCiudad,
        ...pedidosCallCenterConCiudad,
      ];

      const pedidosUnicos = dedupeByCampo2(pedidosCombinados);
      setPedidos(filtrarPorCiudadUsuario(pedidosUnicos));
    } catch (error) {
      console.error('Error al actualizar la fila del pedido:', error);
    }
  };

  const handleNewPedido = (pedido) => {
    const origenLower = (pedido.campo_12 || '').toLowerCase();
    if (origenLower === 'whatsapp') {
      setCurrentWhatsappOrder(pedido.campo_2);
      if (audioRef.current) {
        audioRef.current.loop = true;
        audioRef.current.play().catch(error => {
          console.error('Error al reproducir audio (requiere interacción):', error);
        });
        timeoutRef.current = setTimeout(() => {
          audioRef.current.pause();
        }, 30000);
      }
      setShowWhatsappPopup(true);
    }
  };

  const handleAcceptPopup = () => {
    if (audioRef.current) audioRef.current.pause();
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    setShowWhatsappPopup(false);
    if (currentWhatsappOrder) {
      setNotifiedWhatsappOrders(prev => [...prev, currentWhatsappOrder]);
      setCurrentWhatsappOrder(null);
    }
  };

  const guardarEnArchivo = async (pedido) => {
    try {
      const response = await fetch('https://pedidos.ayvgas.cl/pedidos/guardar_pedido.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pedido),
      });
      if (!response.ok) throw new Error('Error al guardar el pedido');
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  const actualizarPedido = async (pedido) => {
    try {
      const response = await fetch('https://pedidos.ayvgas.cl/pedidos/actualizar_pedido.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pedido),
      });
      if (!response.ok) throw new Error('Error al actualizar el pedido');
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const enviarPedidoAHistorico = async (pedido) => {
    try {
      const response = await fetch('https://pedidos.ayvgas.cl/pedidos/mover_a_historico.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pedido),
      });
      if (!response.ok) throw new Error('Error al mover el pedido a histórico');
      console.log(`Pedido ${pedido.campo_2} movido a histórico`);
    } catch (error) {
      console.error('Error al mover el pedido a histórico:', error);
    }
  };

  const validarCampos = (fila) =>
    fila.campo_4 && fila.campo_7 && fila.campo_8 && fila.campo_11 && fila.campo_yy && fila.campo_12;

  const handleNuevaFilaChange = (e) => {
    const { name, value } = e.target;
    setNuevaFila(prev => ({ ...prev, [name]: value }));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (typeof index === 'number' && index >= 0) {
        if (editando === index) {
          handleGuardarEdicion(index);
        } else if (editandoEstado === index) {
          setEditandoEstado(null);
        }
      } else {
        guardarFila();
      }
    }
  };

  const handleMovilBlur = (index) => {
    const valorIngresado = pedidos[index].campo_11 || '';
    const coincidencias = contactos.filter(c =>
      c.movil.toLowerCase().includes(valorIngresado.toLowerCase())
    );
    if (coincidencias.length === 1) {
      const nuevosPedidos = [...pedidos];
      nuevosPedidos[index].campo_11 = coincidencias[0].movil;
      setPedidos(nuevosPedidos);
    }
  };

  const handleMovilBlurNuevaFila = () => {
    const valorIngresado = nuevaFila.campo_11 || '';
    const coincidencias = contactos.filter(c =>
      c.movil.toLowerCase().includes(valorIngresado.toLowerCase())
    );
    if (coincidencias.length === 1) {
      setNuevaFila(prev => ({ ...prev, campo_11: coincidencias[0].movil }));
    }
  };

  const guardarFila = async () => {
    if (!validarCampos(nuevaFila)) {
      setErrores('Por favor, completa todos los campos obligatorios.');
      return;
    }

    const nuevoPedido = {
      ...nuevaFila,
      campo_1: contadorCampo1,
      campo_5: dayjs().format('DD-MM-YYYY, HH:mm'),
      campo_7: (nuevaFila.campo_7 || '').toUpperCase(),
      latitud: nuevaFila.latitud || '',
      longitud: nuevaFila.longitud || '',
      campo_geocode: nuevaFila.campo_geocode || '',
    };

    try {
      setErrores('');

      // ✅ Si NO viene geocode (no eligieron sugerencia) pero Google sí la encuentra,
      // mostramos popup para elegir: Usar Google / Guardar manual.
      const tieneGoogle = !!window.google?.maps?.Geocoder;
      const sinGeocode = !String(nuevoPedido.campo_geocode || '').trim();
      const direccionTexto = String(nuevoPedido.campo_7 || '').trim();

      if (tieneGoogle && sinGeocode && direccionTexto) {
        const sugerencia = await geocodificarDireccion(direccionTexto, nuevoPedido.campo_yy);

        if (sugerencia) {
          setDireccionSugerida(sugerencia);
          setPedidoPendiente(nuevoPedido);
          setShowDireccionPopup(true);
          return; // detenemos acá hasta que elijan
        }
      }

      // Si Google no encontró nada, se guarda manual directo
      await guardarEnArchivo(nuevoPedido);
      await afterGuardarOK();
    } catch (error) {
      console.error('Error al guardar la fila:', error);
      setErrores('Hubo un error al guardar el pedido.');
    }
  };

  const handleEditar = (index) => {
    setEditando(index);
    setEstaEditando(true);
  };

  const handleGuardarEdicion = async (index) => {
    if (!validarCampos(pedidos[index])) {
      setErrores('Por favor, completa todos los campos obligatorios.');
      return;
    }
    setErrores('');
    setEditando(null);
    setEstaEditando(false);

    const pedidoActualizado = {
      ...pedidos[index],
      origen: pedidos[index].origen,
    };

    try {
      await actualizarPedido(pedidoActualizado);
      await cargarDatos();
    } catch (error) {
      console.error('Error al actualizar el pedido:', error);
    }
  };

  const handleEliminar = async (index) => {
    const pedidoAEliminar = pedidos[index];
    const confirmacion = window.confirm('¿Estás seguro de que deseas eliminar este pedido?');
    if (!confirmacion) return;

    try {
      const response = await fetch('https://pedidos.ayvgas.cl/pedidos/eliminar_pedido_activo.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ campo_2: pedidoAEliminar.campo_2 }),
      });
      if (response.ok) {
        setPedidos(prev => prev.filter((_, i) => i !== index));
      } else {
        throw new Error('Error al eliminar el pedido');
      }
    } catch (error) {
      console.error('Error al eliminar el pedido:', error);
    }

    await cargarDatos();
  };

  const handleCambiarEstado = (index) => {
    setEditandoEstado(index);
  };

  const handleEstadoChange = async (e, index) => {
    const nuevoEstado = e.target.value;
    const nuevosPedidos = [...pedidos];
    const pedidoModificado = { ...nuevosPedidos[index], campo_6: nuevoEstado };

    try {
      await actualizarPedido(pedidoModificado);

      if (nuevoEstado === 'Anulado' || nuevoEstado === 'Entregado') {
        const tiempoTotal = detenerTiempo(pedidoModificado.campo_5);
        pedidoModificado.campo_xx = tiempoTotal;
        await enviarPedidoAHistorico(pedidoModificado);

        const origenLower = (pedidoModificado.campo_12 || '').toLowerCase();
        if (origenLower === 'whatsapp') {
          const responseWhatsapp = await fetch('https://pedidos.ayvgas.cl/pedidos/notificar_whatsapp.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(pedidoModificado),
          });
          if (!responseWhatsapp.ok) throw new Error('Error al notificar por Whatsapp');
          await responseWhatsapp.json();
        }
      }

      await cargarDatos();
    } catch (error) {
      console.error('Error al cambiar el estado del pedido:', error);
    }

    setEditandoEstado(null);
  };

  const detenerTiempo = (fechaPedido) => {
    const fecha = dayjs(fechaPedido, 'DD-MM-YYYY, HH:mm');
    if (!fecha.isValid()) return '00:00:00';
    const ahora = dayjs();
    const diferenciaSegundos = ahora.diff(fecha, 'second');
    return formatearTiempo(diferenciaSegundos);
  };

  const calcularDiferenciaTiempo = (fechaPedido) => {
    const fecha = dayjs(fechaPedido, 'DD-MM-YYYY, HH:mm');
    if (!fecha.isValid()) return { diferenciaMinutos: 0, diferenciaSegundos: 0 };
    const ahora = dayjs();
    const diferenciaMinutos = ahora.diff(fecha, 'minute');
    const diferenciaSegundos = ahora.diff(fecha, 'second');
    return { diferenciaMinutos, diferenciaSegundos };
  };

  const formatearTiempo = (segundosTotales) => {
    const horas = Math.floor(segundosTotales / 3600);
    const minutos = Math.floor((segundosTotales % 3600) / 60);
    const segundos = segundosTotales % 60;
    return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segundos
      .toString()
      .padStart(2, '0')}`;
  };

  const obtenerSemaforoYColor = (diferenciaMinutos) => {
    if (diferenciaMinutos < 6) return { imagen: img1, color: 'verde', nombre: 'Semáforo 1' };
    if (diferenciaMinutos < 12) return { imagen: img2, color: 'amarillo', nombre: 'Semáforo 2' };
    if (diferenciaMinutos < 18) return { imagen: img3, color: 'naranja', nombre: 'Semáforo 3' };
    if (diferenciaMinutos < 24) return { imagen: img4, color: 'rojo', nombre: 'Semáforo 4' };
    return { imagen: img5, color: 'morado', nombre: 'Semáforo 5' };
  };

  const handleEnviarTelegram = async (index) => {
    const pedido = pedidos[index];
    const movil = pedido.campo_11;

    try {
      const response = await fetch('https://pedidos.ayvgas.cl/pedidos/contactos.json');
      if (!response.ok) throw new Error('Error al cargar los contactos');
      const contactosJson = await response.json();
      const contacto = contactosJson.find(c => c.movil === movil);

      if (!contacto) {
        alert(`No se encontró el chat_id_telegram para este móvil: ${movil}`);
        return;
      }

      const chatIdTelegram = contacto.chat_id_telegram;

      const mensaje = [
        `*Pedido ${pedido.campo_2}:*`,
        `*Teléfono del Cliente:* ${pedido.campo_4 || 'No definido'}`,
        `*Dirección:* ${pedido.campo_7 || 'No definida'}`,
        '',
        pedido.campo_8 ? `*Producto1:* ${pedido.campo_8}` : '',
        pedido.campo_9 ? `*Producto2:* ${pedido.campo_9}` : '',
        pedido.campo_13 ? `*Producto3:* ${pedido.campo_13}` : '',
        pedido.campo_14 ? `*Producto4:* ${pedido.campo_14}` : '',
        '',
        `*Estado:* ${pedido.campo_6 || 'No definido'}`,
        `*Ciudad:* ${pedido.campo_yy || 'No definida'}`,
      ]
        .filter(line => line)
        .join('\n');

      const tecladoEnLinea = {
        inline_keyboard: [
          [
            {
              text: '📞 Contactar al Cliente',
              url: `https://pedidos.ayvgas.cl/llamar.html?telefono=${encodeURIComponent(pedido.campo_4)}`,
            },
          ],
        ],
      };

      // ⚠️ Idealmente esto debe ir en backend (PHP) para no exponer el token en el frontend
      const TELEGRAM_BOT_TOKEN = '7463925088:AAHPDr0alFLRsp_2nAr429Oe-AzinIRKPqo';
      const urlTelegram = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`;

      const sendMessageResponse = await fetch(urlTelegram, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          chat_id: chatIdTelegram,
          text: mensaje,
          parse_mode: 'Markdown',
          reply_markup: tecladoEnLinea,
        }),
      });

      const result = await sendMessageResponse.json();
      console.log('Telegram API Response:', result);

      if (!sendMessageResponse.ok) {
        console.error('Error al enviar el mensaje de Telegram:', result);
        throw new Error(result.description || 'Error al enviar el mensaje');
      }

      alert('Mensaje enviado correctamente a Telegram');
    } catch (error) {
      console.error('Error al enviar el mensaje:', error.message);
      alert(`Hubo un error al enviar el mensaje: ${error.message}`);
    }
  };

  // ---- Render ----
  return (
    <div className="pedidos-container">
      <header>
        <MobileStatus />
      </header>

      <h1>Pedidos Activos</h1>

      {/* ✅ PANEL STICKY: SIEMPRE PODRÁS AGREGAR PEDIDOS, AUNQUE HAYA MUCHÍSIMOS */}
      <div className="nuevo-pedido-sticky">
        <div className="nuevo-pedido-grid">
          <div>
            <label>N° Pedido</label>
            <div className="readonly">{nuevaFila.campo_2}</div>
          </div>

          <div>
            <label>Teléfono *</label>
            <input
              type="text"
              name="campo_4"
              value={nuevaFila.campo_4}
              onChange={handleNuevaFilaChange}
              onKeyDown={(e) => handleKeyDown(e)}
              autoComplete="off"
            />
          </div>

          <div>
            <label>Dirección *</label>
            <input
              ref={inputDireccionRef}
              type="text"
              name="campo_7"
              value={nuevaFila.campo_7}
              onChange={(e) => {
                handleNuevaFilaChange(e);
                // ✅ Si la admin escribe manual, dejamos geocode vacío (solo se llena si selecciona sugerencia)
                setNuevaFila(prev => ({
                  ...prev,
                  latitud: '',
                  longitud: '',
                  campo_geocode: '',
                }));
              }}
              onKeyDown={(e) => handleKeyDown(e)}
              autoComplete="off"
            />
          </div>

          <div>
            <label>Producto1 *</label>
            <select
              name="campo_8"
              value={nuevaFila.campo_8}
              onChange={handleNuevaFilaChange}
              onKeyDown={(e) => handleKeyDown(e)}
            >
              <option value="">Seleccionar</option>
              {opcionesProductos.map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Producto2</label>
            <select
              name="campo_9"
              value={nuevaFila.campo_9}
              onChange={handleNuevaFilaChange}
              onKeyDown={(e) => handleKeyDown(e)}
            >
              <option value="">Seleccionar</option>
              {opcionesProductos.map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Producto3</label>
            <select
              name="campo_13"
              value={nuevaFila.campo_13}
              onChange={handleNuevaFilaChange}
              onKeyDown={(e) => handleKeyDown(e)}
            >
              <option value="">Seleccionar</option>
              {opcionesProductos.map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Producto4</label>
            <select
              name="campo_14"
              value={nuevaFila.campo_14}
              onChange={handleNuevaFilaChange}
              onKeyDown={(e) => handleKeyDown(e)}
            >
              <option value="">Seleccionar</option>
              {opcionesProductos.map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Móvil *</label>
            <input
              type="text"
              list="movilOptions-new"
              name="campo_11"
              value={nuevaFila.campo_11}
              onChange={handleNuevaFilaChange}
              onBlur={handleMovilBlurNuevaFila}
              onKeyDown={(e) => handleKeyDown(e)}
              autoComplete="off"
            />
            <datalist id="movilOptions-new">
              {construirOpcionesMovil(contactos, nuevaFila.campo_11).map(op => (
                <option key={`${op.movil}-${op.etiqueta}`} value={op.movil}>
                  {op.etiqueta}
                </option>
              ))}
            </datalist>
          </div>

          <div>
            <label>Origen *</label>
            <select
              name="campo_12"
              value={nuevaFila.campo_12}
              onChange={handleNuevaFilaChange}
              onKeyDown={(e) => handleKeyDown(e)}
            >
              <option value="">Seleccionar Origen</option>
              {opcionesOrigen.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Ciudad *</label>
            <select
              name="campo_yy"
              value={nuevaFila.campo_yy}
              onChange={handleNuevaFilaChange}
              required
              disabled={!puedeElegirCiudad}
            >
              <option value="">Seleccionar Ciudad</option>
              {(puedeElegirCiudad ? opcionesCiudad : [ciudadPermitida]).map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>

          <div className="nuevo-pedido-actions">
            <button type="button" onClick={guardarFila}>
              Guardar
            </button>
            <div className="hint">También puedes guardar con Enter</div>
          </div>
        </div>

        {errores && <p style={{ color: 'red', marginTop: 8 }}>{errores}</p>}
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>N° del Pedido</th>
              <th>Semáforo</th>
              <th>Teléfono</th>
              <th>Fecha</th>
              <th>Estado</th>
              <th>Dirección</th>
              <th>Producto1</th>
              <th>Producto2</th>
              <th>Producto3</th>
              <th>Producto4</th>
              <th>Movil</th>
              <th>Origen</th>
              <th>Ciudad</th>
              <th>Tiempo</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {pedidos.map((pedido, index) => {
              // tick fuerza re-render 1s (sin copiar pedidos)
              void tick;

              const { diferenciaMinutos, diferenciaSegundos } = calcularDiferenciaTiempo(pedido.campo_5);
              const { imagen: imagenSemaforo } = obtenerSemaforoYColor(diferenciaMinutos);
              const tiempoFormateado = formatearTiempo(diferenciaSegundos);

              const isEditing = editando === index;
              const isEditingEstado = editandoEstado === index;

              return (
                <tr key={pedido.campo_2 || index}>
                  <td data-label="#">{pedido.campo_1}</td>

                  <td data-label="N° Pedido" className="ellipsis">{pedido.campo_2}</td>

                  <td data-label="Semáforo">
                    <img src={imagenSemaforo} alt="Semáforo" width="50" />
                  </td>

                  <td data-label="Teléfono">
                    {isEditing ? (
                      <input
                        type="text"
                        name="campo_4"
                        value={pedido.campo_4}
                        onChange={(e) => handleEditChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        autoComplete="off"
                      />
                    ) : (
                      pedido.campo_4
                    )}
                  </td>

                  <td data-label="Fecha">{pedido.campo_5}</td>

                  <td data-label="Estado">
                    {isEditingEstado ? (
                      <select
                        value={pedido.campo_6}
                        onChange={(e) => handleEstadoChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                      >
                        {opcionesEstado.map((estado) => (
                          <option key={estado} value={estado}>
                            {estado}
                          </option>
                        ))}
                      </select>
                    ) : (
                      pedido.campo_6
                    )}
                  </td>

                  <td data-label="Dirección" className="text-left ellipsis">
                    {isEditing ? (
                      <input
                        type="text"
                        name="campo_7"
                        value={pedido.campo_7}
                        onChange={(e) => handleEditChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        autoComplete="off"
                      />
                    ) : (
                      pedido.campo_7
                    )}
                  </td>

                  <td data-label="Producto1">
                    {isEditing ? (
                      <select name="campo_8" value={pedido.campo_8} onChange={(e) => handleEditChange(e, index)}>
                        <option value="">Seleccionar</option>
                        {opcionesProductos.map((producto) => (
                          <option key={producto} value={producto}>
                            {producto}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <span>{pedido.campo_8}</span>
                    )}
                  </td>

                  <td data-label="Producto2">
                    {isEditing ? (
                      <select name="campo_9" value={pedido.campo_9} onChange={(e) => handleEditChange(e, index)}>
                        <option value="">Seleccionar</option>
                        {opcionesProductos.map((producto) => (
                          <option key={producto} value={producto}>
                            {producto}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <span>{pedido.campo_9}</span>
                    )}
                  </td>

                  <td data-label="Producto3">
                    {isEditing ? (
                      <select name="campo_13" value={pedido.campo_13} onChange={(e) => handleEditChange(e, index)}>
                        <option value="">Seleccionar</option>
                        {opcionesProductos.map((producto) => (
                          <option key={producto} value={producto}>
                            {producto}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <span>{pedido.campo_13}</span>
                    )}
                  </td>

                  <td data-label="Producto4">
                    {isEditing ? (
                      <select name="campo_14" value={pedido.campo_14} onChange={(e) => handleEditChange(e, index)}>
                        <option value="">Seleccionar</option>
                        {opcionesProductos.map((producto) => (
                          <option key={producto} value={producto}>
                            {producto}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <span>{pedido.campo_14}</span>
                    )}
                  </td>

                  <td data-label="Móvil">
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          name="campo_11"
                          value={pedido.campo_11}
                          onChange={(e) => handleEditChange(e, index)}
                          onBlur={() => handleMovilBlur(index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          list={`movilOptions-${index}`}
                          autoComplete="off"
                        />
                        <datalist id={`movilOptions-${index}`}>
                          {construirOpcionesMovil(contactos, pedido.campo_11).map(opcion => (
                            <option key={`${opcion.movil}-${opcion.etiqueta}`} value={opcion.movil}>
                              {opcion.etiqueta}
                            </option>
                          ))}
                        </datalist>
                      </>
                    ) : (
                      pedido.campo_11
                    )}
                  </td>

                  <td data-label="Origen">
                    {isEditing ? (
                      <select
                        name="campo_12"
                        value={pedido.campo_12}
                        onChange={(e) => handleEditChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                      >
                        <option value="">Seleccionar Origen</option>
                        {opcionesOrigen.map((origen) => (
                          <option key={origen} value={origen}>
                            {origen}
                          </option>
                        ))}
                      </select>
                    ) : (
                      pedido.campo_12
                    )}
                  </td>

                  <td data-label="Ciudad">
                    {isEditing ? (
                      <select
                        name="campo_yy"
                        value={pedido.campo_yy}
                        onChange={(e) => handleEditChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                      >
                        <option value="">Seleccionar Ciudad</option>
                        {opcionesCiudad.map((ciudad) => (
                          <option key={ciudad} value={ciudad}>
                            {ciudad}
                          </option>
                        ))}
                      </select>
                    ) : (
                      pedido.campo_yy
                    )}
                  </td>

                  <td data-label="Tiempo">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span>{tiempoFormateado}</span>
                    </div>
                  </td>

                  <td data-label="Acciones">
                    <div className="actions-cell">
                      {isEditing ? (
                        <img
                          src={editarImg}
                          alt="Guardar"
                          width="30"
                          onClick={async () => {
                            await handleGuardarEdicion(index);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <img
                          src={editarImg}
                          alt="Editar"
                          width="30"
                          onClick={() => handleEditar(index)}
                          style={{ cursor: 'pointer' }}
                        />
                      )}

                      <img
                        src={eliminarImg}
                        alt="Eliminar"
                        width="30"
                        onClick={async () => {
                          await handleEliminar(index);
                        }}
                        style={{ cursor: 'pointer' }}
                      />

                      <img
                        src={cambiarEstadoImg}
                        alt="Cambiar Estado"
                        width="30"
                        onClick={() => {
                          if (editandoEstado === index) setEditandoEstado(null);
                          else handleCambiarEstado(index);
                        }}
                        style={{ cursor: 'pointer' }}
                      />

                      <img
                        src={telegramImg}
                        alt="Telegram"
                        width="30"
                        onClick={() => handleEnviarTelegram(index)}
                        style={{ cursor: 'pointer' }}
                      />

                      <img
                        src={nuevoBotonImg}
                        alt="Mapa"
                        width="30"
                        onClick={() => navigate(`/welcome/mapa/${pedido.campo_yy}`)}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {showWhatsappPopup && (
          <div className="popup">
            <p>Pedido de WhatsApp entrante: {currentWhatsappOrder}</p>
            <button className="popup-button" onClick={handleAcceptPopup}>
              Aceptar
            </button>
          </div>
        )}

        {/* ✅ Popup para elegir dirección (Google encontró una coincidencia) */}
        {showDireccionPopup && (
          <div className="popup">
            <p style={{ marginBottom: 8 }}>
              Google encontró una dirección similar. ¿Cuál quieres guardar?
            </p>

            <div style={{ textAlign: 'left', fontSize: 14, marginBottom: 10 }}>
              <div><strong>Escrita:</strong> {pedidoPendiente?.campo_7 || ''}</div>
              <div><strong>Sugerida Google:</strong> {(direccionSugerida?.formatted || '').toUpperCase()}</div>
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="popup-button" onClick={handleUsarDireccionGoogle}>
                Usar Google ✅
              </button>
              <button className="popup-button" onClick={handleGuardarManualDireccion}>
                Guardar manual ✍️
              </button>
              <button
                className="popup-button"
                onClick={() => {
                  // cerrar sin guardar (por si se equivocaron)
                  limpiarPopupDireccion();
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Pedidos;
